import { Modal } from 'antd'
import { FormArticle, ViewArticle } from './components'
import { useModalArticle } from 'src/pages/budget/budgetCategories/hook'
import { closeModalArticle } from 'src/pages/budget/budgetCategories/model'
import { ModeArticle } from 'src/pages/budget/budgetCategories/types'

export const ModalArticle = () => {
  const modalArticleStore = useModalArticle()
  if (!modalArticleStore) return null

  const { article, mode } = modalArticleStore

  const open = Boolean(modalArticleStore)

  const titles: Record<ModeArticle, string> = {
    view: 'Просмотр статьи бюджета',
    edit: 'Редактировать статью бюджета',
    new: 'Добавить новую статью бюджета',
  }

  const content = {
    view: article ? (
      <ViewArticle article={article} />
    ) : (
      <div>Нет данных статьи</div>
    ),
    edit: article ? (
      <FormArticle article={article} />
    ) : (
      <div>Нет данных статьи</div>
    ),
    new: <FormArticle article={null} />,
  }

  return (
    <Modal
      title={<div style={{ fontSize: 32 }}>{titles[mode]}</div>}
      centered
      wrapClassName="ant_modal"
      width={600}
      maskClosable={false}
      open={open}
      destroyOnHidden
      onCancel={() => closeModalArticle()}
      footer={null}
    >
      <>{content[mode]}</>
    </Modal>
  )
}
